import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router';
import config from '@/config';
import NotFoundView from '@/components/root/error/NotFoundView.vue';
import NewsApp from '@/components/news/NewsApp.vue';
import PageRedirect from '@/components/cores/PageRedirect.vue';

const routes: Readonly<RouteRecordRaw[]> = [
  {
    path: '/page_preview/',
    name: 'PreviewView',
    component: () => import('@/components/cms/PreviewView.vue'),
    meta: {public: true},
  },
  {path: '', name: 'root-redirect', redirect: {path: '/home'}},
  {path: '/core/home/:pathMatch(.*)*', redirect: {path: '/home'}},
  {path: '/news/:id?', name: 'news', component: NewsApp},
  {
    path: '/cookiepolicy',
    name: 'cookiepolicy',
    component: () => import('@/components/root/CookiePolicyView.vue'),
    props: true,
  },
  {path: '/core/:core/:corePath+', component: PageRedirect},
  {
    path: '/feedback/:source_system/:identifier/:guid',
    component: () => import('@/components/feedback/FeedbackView.vue'),
    meta: {public: true},
  },
  {
    path: '/feedback/',
    component: () => import('@/components/feedback/FeedbackView.vue'),
    meta: {public: true},
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/components/cores/DashboardView/DashboardView.vue'),
  },
  {path: '/:pathMatch(.*)*', name: 'not-found', component: NotFoundView},
];

// Reusable function for isolated tests
export function buildRouter() {
  return createRouter({
    history: createWebHistory(config.BASE_URL),
    routes,
    linkActiveClass: 'active',
    scrollBehavior() {
      return {left: 0, top: 0};
    },
  });
}

const router = buildRouter();

// N.B. It's essential to keep track of the previous page for translations
router.beforeEach((to, from) => {
  to.meta.previousRoute = from;
});

export default router;
